<template>
  <v-card class="main-content-card" flat id="proj-cw-lkxx-card">
    <v-toolbar flat>
      <v-toolbar-title>批量到款认领</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn color="primary" outline
             :disabled="!funcIds.includes('c_proj_inco_claim')"
             @click.native.stop="
             () => {lkxx=true;} ">
        <v-icon>search</v-icon>
        检索认领来款
      </v-btn>
    </v-toolbar>
    <v-divider/>
    <v-form ref="formRef">
      <v-container grid-list-md class="pt-0">
        <v-layout wrap>
          <v-flex xs3>
            <v-text-field
                label="对方单位"
                :rules="rules.required"
                v-model="form.dfdw"
            />
          </v-flex>
          <v-flex sm3>
            <v-menu
                ref="refPzrqStart"
                :close-on-content-click="false"
                v-model="menuPzrqStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="form.pzrqStart"
                  label="凭证日期(起始)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD"
                  persistent-hint
              />
              <v-date-picker
                  v-model="pzrqStart"
                  locale="zh-cn"
                  @change="nv => form.pzrqStart= nv"
              />
            </v-menu>
          </v-flex>

          <v-flex sm3>
            <v-menu
                ref="refPzrqEnd"
                :close-on-content-click="false"
                v-model="menuPzrqEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="form.pzrqEnd"
                  label="凭证日期(截止)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD"
                  persistent-hint
              />
              <v-date-picker
                  v-model="pzrqEnd"
                  locale="zh-cn"
                  @change="nv => form.pzrqEnd= nv"
              />
            </v-menu>
          </v-flex>

          <v-flex sm2>
            <v-autocomplete
                clearable
                v-model="form.code"
                :items="statusItems"
                label="状态"
                :return-object="false"
            />
          </v-flex>

          <v-flex sm1 class="text-xs-right">
            <v-btn color="primary" @click.native="onSearch">检索</v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </v-form>
    <v-divider/>

    <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-0"
        :loading="isLoading"
        :pagination.sync="query"
        :rows-per-page-items="[25, 50, 100]"
        no-data-text="没有数据。">
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ props.index + 1 }}</td>
        <td class="">{{ props.item.zy }}<br/>{{ props.item.dfdw }}<br/>{{ props.item.pznm }}</td>
        <td class="text-xs-right"><span class="subheading">{{ props.item.je | currency }}</span><br/>
          {{ props.item.pzrq.slice(0, 4) }}-{{ props.item.pzrq.slice(4, 6) }}-{{ props.item.pzrq.slice(6, 8) }}
        </td>
        <td class="">{{ props.item.claimName }}<br/>{{ props.item.rkrq }}</td>
        <td class="">{{ props.item.msg }}</td>

        <td class="justify-center layout px-0">
<!--          <v-tooltip top>-->
<!--            <v-btn icon class="mx-0" slot="activator"-->
<!--                   @click="-->
<!--                         () => {-->
<!--                            viewDbid = props.item.dbid; view = true;-->
<!--                         }">-->
<!--              <v-icon color="teal">more_horiz</v-icon>-->
<!--            </v-btn>-->
<!--            <span>查看</span>-->
<!--          </v-tooltip>-->

          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   :disabled="props.item.code <= 1 || !funcIds.includes('c_proj_inco_claim')"
                   @click="
                         () => {
                            printDbid = props.item.dbid;
                            print = true;
                         }"><!--原代码为props.item.code <= 2，根据中医大需要改为props.item.code <= 1-->
              <v-icon color="teal">print</v-icon>
            </v-btn>
            <span>打印</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn
                icon class="mx-0" slot="activator"
                :disabled="!funcIds.includes('c_proj_inco_claim')"
                @click="
                     () => {
                        editDbid = props.item.dbid;
                        edit = true;
                     }">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>批量建帐</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn
                icon class="mx-0" slot="activator"
                :disabled="props.item.code>= 3 || !funcIds.includes('d_proj_inco_claim')"
                @click="
                     () => {
                        deleDbid = props.item.dbid;
                        deleMsg = `${props.item.je}元 / ${props.item.dfdw}`;
                        dele = true;
                     }">
              <v-icon color="pink">delete_forever</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>

      </template>
    </v-data-table>

    <x-view
        v-model="view"
        :dbid="viewDbid"/>

    <x-lkxx
        v-model="lkxx"
        title="查询来款信息"
        v-on:ok="onLkxxOk"
    />

    <x-edit
        v-model="edit"
        :dbid="editDbid"
        v-on:ok="onEditOk"/>

    <x-delete
        v-model="dele"
        :message="deleMsg"
        :uri="uri"
        :dbid="deleDbid"
        v-on:ok="onDeleOk"/>

    <x-print
        v-model="print"
        :dbid="printDbid"/>

  </v-card>
</template>
<script>
import {mapGetters} from 'vuex'

import XEdit from './Edit'
import XView from './View'
import XLkxx from './Lkxx'
import XPrint from './Print'


import XDelete from '@/components/global/Delete'

const baseURI = '/api/proj/cw_lkxx';

export default {
  components: {XEdit, XDelete, XView, XLkxx, XPrint},

  props: {
    project: Object
  },
  data: () => ({

    uri: baseURI,
    isLoading: false,

    form: {
      dfdw: "",
      pzrqStart: "",
      pzrqEnd: "",
      code: ""
    },

    query: {
      page: 1,
      rowsPerPage: 25,
      sortBy: 'rkrq',
      descending: true,
      totalItems: null
    },

    headers: [
      {
        text: '#',
        sortable: false,
        value: 'dbid',
        width: '20'
      },
      // {text: '#', sortable: false, value: 'rank', width: 18},
      {text: '来款描述/对方单位/来款ID', sortable: false, value: 'dfdw', align: 'left'},
      {text: '金额(元)/来款日期', sortable: false, value: 'pzrq', width: 150, align: 'left'},
      {text: '认款人/认款日期', sortable: false, value: 'claimName', width: 150, align: 'left'},
      {text: '状态', value: 'msg', sortable: false, align: 'left', width: 200},
      {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 120}
    ],

    items: [],

    statusItems: [
      {value: "0", text: '新认领到款'},
      {value: "1", text: '到款已分配到项目'},
      {value: "2", text: '完成经费拆分'},
      {value: "3", text: '数据已共享，财务未处理'},
      {value: "4", text: '数据已共享，财务已处理'},
    ],

    lkxx: false,

    view: false,
    viewDbid: null,

    print: false,
    printDbid: null,

    edit: false,
    editDbid: null,

    dele: false,
    deleDbid: null,
    deleMsg: null,

    pzrqStart: '',
    menuPzrqStart: false,

    pzrqEnd: '',
    menuPzrqEnd: false,

    /**
     * 验证规则
     */
    rules: {}
  }),

  computed: {
    ...mapGetters(['funcIds'])
  },

  watch: {},

  created() {
    Object.assign(this.query, this.form);
    this.query.page = 1;
    this.isLoading = true;
    this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
        .then(
            rsp => {
              this.isLoading = false;
              this.items = rsp.data.items;
            })
        .finally(() => this.isLoading = false);
  },

  methods: {
    onSearch() {
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.isLoading = true;
      this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
          .then(
              rsp => {
                this.isLoading = false;
                this.items = rsp.data.items;
              })
          .finally(() => this.isLoading = false);
    },
    onLkxxOk() {
      this.onSearch();
    },
    onEditOk() {
      this.onSearch();
    },

    onDeleOk(item) {
      if (item) {
        const deleIdx = this.items.findIndex(v => v.dbid === item.dbid);
        this.items.splice(deleIdx, 1);
      }
    },
  }
}
</script>
